import { http } from '@/http/axios.js'
export function getIndexStatAPI() {
  return http({
    url: '/api/manage/datav/stat',
    method: 'POST',
  })
}
